/**
 * Optional: set window.__HR_DEBUG_PRICING__ = true in devtools to enable
 * hrDebugTrace() / hrDebugError() output (console is restored for those).
 */
export function isHrDebugPricing() {
  if (!import.meta.env?.DEV) return false;
  return typeof window !== "undefined" && window.__HR_DEBUG_PRICING__ === true;
}

export function hrDebugTrace(tag, payload) {
  if (!isHrDebugPricing()) return;
  const orig = typeof window !== "undefined" ? window.__HR_ORIGINAL_CONSOLE_INFO__ : null;
  if (orig) {
    try {
      orig.call(console, tag, payload);
    } catch {
      /* ignore */
    }
  }
}

export function hrDebugError(tag, payload) {
  if (!isHrDebugPricing()) return;
  if (typeof console !== "undefined" && typeof console.error === "function") {
    try {
      console.error(tag, payload);
    } catch {
      /* ignore */
    }
  }
}
